module.exports = __webpack_public_path__ + "img/eliza6.230405a9.png";